import React from 'react';

import { Box } from '@chakra-ui/react';

import { TextBodyMedium, TextBodyLarge } from 'uiToolkitV1/Typography';

export const HeaderCellTooltip = (props) => {
  if (!props.value) return null;
  return (
    <Box display="inline-block" maxWidth="310px" border="solid 1px #999999" borderRadius="4px" bgColor="black" p={2}>
      {props.showColumnName && (
        <TextBodyLarge color="white" bold>
          {props.colDef.headerName}
        </TextBodyLarge>
      )}
      <TextBodyMedium color="white">{props.value}</TextBodyMedium>
    </Box>
  );
};
